<ng-container *transloco="let t;">

  <p-card>
    <app-reporting-table
      [type]="'observerlist'"
    ></app-reporting-table>
  </p-card>

</ng-container>
